const maxHeight = 600;
const maxWidth = 800;

export const resizeJPEGFiles = files => {
  return Promise.all(
    files.map(
      file =>
        (file.type.match('image/jpeg') && resizeJPEGImage(file)) ||
        Promise.resolve(file)
    )
  );
};

export const resizeJPEGImage = file => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => {
      const image = new Image();
      image.src = event.target.result;
      image.onload = async () => {
        const blob = await resizeImage(image);
        resolve(new File([blob], file.name, file));
      };
    };
  });
};

const resizeImage = image => {
  const canvas = getImageCanvas(image);
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  return new Promise(resolve =>
    context.canvas.toBlob(resolve, 'image/jpeg', 1)
  );
};

const getImageCanvas = image => {
  const canvas = document.createElement('canvas');
  const scale = getFactor(image);
  canvas.height = image.height * scale;
  canvas.width = image.width * scale;
  return canvas;
};

const getFactor = image => {
  const scaleInHeight = image.height > maxHeight ? maxHeight / image.height : 1;
  const scaleInWidth = image.width > maxWidth ? maxWidth / image.width : 100;

  return Math.min(scaleInHeight, scaleInWidth);
};
